// extracted by mini-css-extract-plugin
export default {"floating-add-folder-button":"FloatingAddFolderButton_floating-add-folder-button__LY-+-","floating-add-folder-icon":"FloatingAddFolderButton_floating-add-folder-icon__AbsUX"};